import { c as _c } from "react/compiler-runtime";
import last from 'lodash/last';
import omit from 'lodash/omit';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { parseAsArrayOf, parseAsBoolean, parseAsInteger, parseAsString, useQueryStates } from 'nuqs';
import getDateRange from '@/utils/get-date-range';
export const PLAYBOOK_KEYS_Q = 'playbook_ids';
export const PLAYBOOK_VERSION_Q = 'playbook_version';
export type EntitiesQueryParams = {
  state: string;
  // pass, fail,none
  verification: string;
  dateRangeStart: string;
  dateRangeEnd: string;
  watchlistHit: boolean;
  search: string;
  cursor: string;
  pageSize: number;
  // this is a boolean but we need to pass as a string for URL; incompatible w/ index signature otherwise
  requiresManualReview: boolean;
  // this is a boolean but we need to pass as a string for URL; incompatible w/ index signature otherwise
  hasOutstandingWorkflowRequest: boolean;
  showUnverified: boolean;
  labels: string[];
  tags: string[];
  playbookIds: string[];
  playbookVersion: string;
  externalId: string;
};
export enum EntityStatusFilter {
  pass = 'pass',
  failed = 'fail',
  incomplete = 'incomplete',
  inProgress = 'in_progress',
  pending = 'pending',
  none = 'none',
  complete = 'complete',
  manualReview = 'manual_review',
}
const defaultQueryParams: EntitiesQueryParams = {
  state: '',
  verification: '',
  dateRangeStart: '',
  dateRangeEnd: '',
  watchlistHit: false,
  search: '',
  cursor: '',
  pageSize: 12,
  requiresManualReview: false,
  hasOutstandingWorkflowRequest: false,
  showUnverified: false,
  labels: [],
  tags: [],
  playbookIds: [],
  playbookVersion: '',
  externalId: ''
};
const useEntitiesQueryParams = () => {
  const $ = _c(34);
  const router = useRouter();
  const urlSearchParams = useSearchParams();
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsString.withDefault(defaultQueryParams.state);
    t1 = parseAsString.withDefault(defaultQueryParams.verification);
    t2 = parseAsString.withDefault(defaultQueryParams.dateRangeStart);
    t3 = parseAsString.withDefault(defaultQueryParams.dateRangeEnd);
    t4 = parseAsBoolean.withDefault(defaultQueryParams.watchlistHit);
    t5 = parseAsString.withDefault(defaultQueryParams.search);
    t6 = parseAsString.withDefault(defaultQueryParams.cursor);
    t7 = parseAsInteger.withDefault(defaultQueryParams.pageSize);
    t8 = parseAsBoolean.withDefault(defaultQueryParams.requiresManualReview);
    t9 = parseAsBoolean.withDefault(defaultQueryParams.hasOutstandingWorkflowRequest);
    t10 = parseAsBoolean.withDefault(defaultQueryParams.showUnverified);
    t11 = parseAsArrayOf(parseAsString).withDefault(defaultQueryParams.labels);
    t12 = parseAsArrayOf(parseAsString).withDefault(defaultQueryParams.tags);
    $[0] = t0;
    $[1] = t1;
    $[2] = t10;
    $[3] = t11;
    $[4] = t12;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t0 = $[0];
    t1 = $[1];
    t10 = $[2];
    t11 = $[3];
    t12 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = parseAsArrayOf(parseAsString).withDefault(defaultQueryParams.playbookIds);
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      state: t0,
      verification: t1,
      date_range_start: t2,
      date_range_end: t3,
      watchlist_hit: t4,
      search: t5,
      cursor: t6,
      page_size: t7,
      requires_manual_review: t8,
      has_outstanding_workflow_request: t9,
      show_unverified: t10,
      labels: t11,
      tags: t12,
      [PLAYBOOK_KEYS_Q]: t13,
      [PLAYBOOK_VERSION_Q]: parseAsString.withDefault(defaultQueryParams.playbookVersion),
      external_id: parseAsString.withDefault(defaultQueryParams.externalId)
    };
    t15 = {
      history: "push",
      clearOnDefault: true
    };
    $[14] = t14;
    $[15] = t15;
  } else {
    t14 = $[14];
    t15 = $[15];
  }
  const [queryParams, setQueryParams] = useQueryStates(t14, t15);
  const getStatusAndManualReviewParams = _temp;
  let count;
  let push;
  let requestParams;
  let searchParams;
  let values;
  if ($[16] !== queryParams || $[17] !== setQueryParams || $[18] !== urlSearchParams) {
    push = newQuery => {
      const updated = {
        ...values,
        ...newQuery
      };
      setQueryParams({
        state: updated.state ?? defaultQueryParams.state,
        verification: updated.verification ?? defaultQueryParams.verification,
        date_range_start: updated.dateRangeStart ?? defaultQueryParams.dateRangeStart,
        date_range_end: updated.dateRangeEnd ?? defaultQueryParams.dateRangeEnd,
        watchlist_hit: updated.watchlistHit ?? defaultQueryParams.watchlistHit,
        search: updated.search ?? defaultQueryParams.search,
        cursor: updated.cursor ?? defaultQueryParams.cursor,
        page_size: updated.pageSize ?? defaultQueryParams.pageSize,
        requires_manual_review: updated.requiresManualReview ?? defaultQueryParams.requiresManualReview,
        has_outstanding_workflow_request: updated.hasOutstandingWorkflowRequest ?? defaultQueryParams.hasOutstandingWorkflowRequest,
        show_unverified: updated.showUnverified ?? defaultQueryParams.showUnverified,
        labels: updated.labels ?? defaultQueryParams.labels,
        tags: updated.tags ?? defaultQueryParams.tags,
        [PLAYBOOK_KEYS_Q]: updated.playbookIds ?? defaultQueryParams.playbookIds,
        [PLAYBOOK_VERSION_Q]: updated.playbookVersion ?? defaultQueryParams.playbookVersion,
        external_id: updated.externalId ?? defaultQueryParams.externalId
      });
    };
    values = {
      state: queryParams.state,
      verification: queryParams.verification,
      dateRangeStart: queryParams.date_range_start,
      dateRangeEnd: queryParams.date_range_end,
      dateRange: [queryParams.date_range_start, queryParams.date_range_end].filter(_temp2),
      watchlistHit: queryParams.watchlist_hit,
      search: queryParams.search,
      cursor: queryParams.cursor,
      pageSize: queryParams.page_size,
      requiresManualReview: queryParams.requires_manual_review,
      hasOutstandingWorkflowRequest: queryParams.has_outstanding_workflow_request,
      showUnverified: queryParams.show_unverified,
      labels: queryParams.labels,
      tags: queryParams.tags,
      playbookIds: queryParams[PLAYBOOK_KEYS_Q],
      playbookVersion: queryParams[PLAYBOOK_VERSION_Q],
      externalId: queryParams.external_id
    };
    const {
      from,
      to
    } = getDateRange(values.dateRange);
    const cursors = values.cursor.split(",");
    const lastCursor = last(cursors);
    requestParams = {
      cursor: lastCursor ? Number.parseInt(lastCursor, 10) : undefined,
      search: values.search.length ? values.search : undefined,
      labels: values.labels.length ? values.labels : undefined,
      tags: values.tags.length ? values.tags : undefined,
      pageSize: values.pageSize > 0 ? values.pageSize : undefined,
      timestampGte: from || undefined,
      timestampLte: to || undefined,
      watchlistHit: values.watchlistHit || undefined,
      hasOutstandingWorkflowRequest: values.hasOutstandingWorkflowRequest || undefined,
      showUnverified: values.showUnverified || undefined,
      showAll: values.showUnverified || undefined,
      playbookIds: values.playbookIds?.length ? values.playbookIds : undefined,
      playbookVersion: values.playbookVersion || undefined,
      externalId: values.externalId || undefined,
      ...getStatusAndManualReviewParams({
        state: values.state,
        verification: values.verification,
        requiresManualReview: values.requiresManualReview
      })
    };
    let t16;
    if ($[24] !== urlSearchParams) {
      const urlSearchParamsObj = Object.fromEntries(urlSearchParams);
      const listSearchParams = omit(urlSearchParamsObj, ["onboarding_id", "onboarding_section"]);
      t16 = new URLSearchParams(listSearchParams).toString();
      $[24] = urlSearchParams;
      $[25] = t16;
    } else {
      t16 = $[25];
    }
    searchParams = t16;
    count = 0;
    if (values.watchlistHit) {
      count = 1;
    }
    if (values.hasOutstandingWorkflowRequest) {
      count = count + 1;
    }
    if (values.showUnverified) {
      count = count + 1;
    }
    if (values.labels.length) {
      count = count + values.labels.length;
    }
    if (values.tags.length) {
      count = count + values.tags.length;
    }
    if (values.dateRange.length) {
      const isDefault = values.dateRange.includes("all-time");
      if (!isDefault) {
        count = count + 1;
      }
    }
    $[16] = queryParams;
    $[17] = setQueryParams;
    $[18] = urlSearchParams;
    $[19] = count;
    $[20] = push;
    $[21] = requestParams;
    $[22] = searchParams;
    $[23] = values;
  } else {
    count = $[19];
    push = $[20];
    requestParams = $[21];
    searchParams = $[22];
    values = $[23];
  }
  if (values.playbookIds?.length) {
    count = count + values.playbookIds.length;
  }
  if (values.playbookVersion) {
    count = count + 1;
  }
  if (values.externalId) {
    count = count + 1;
  }
  const filtersCount = count;
  const hasFilters = filtersCount > 0;
  let t16;
  if ($[26] !== filtersCount || $[27] !== hasFilters || $[28] !== push || $[29] !== requestParams || $[30] !== router.isReady || $[31] !== searchParams || $[32] !== values) {
    t16 = {
      hasFilters,
      filtersCount,
      requestParams,
      values,
      push,
      isReady: router.isReady,
      searchParams
    };
    $[26] = filtersCount;
    $[27] = hasFilters;
    $[28] = push;
    $[29] = requestParams;
    $[30] = router.isReady;
    $[31] = searchParams;
    $[32] = values;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
};
export default useEntitiesQueryParams;
function _temp(t0) {
  const {
    state,
    verification,
    requiresManualReview
  } = t0;
  if (!state && !verification) {
    return {};
  }
  if (state === "incomplete") {
    return {
      statuses: ["incomplete", "pending"].join(),
      requiresManualReview: false
    };
  }
  if (!verification) {
    return {
      statuses: ["pass", "fail", "none"].join(),
      requiresManualReview
    };
  }
  return {
    statuses: verification,
    requiresManualReview
  };
}
function _temp2(v) {
  return v.length > 0;
}